import React from 'react'
import { Box, Button, Paper, Stack, Tooltip, Typography } from '@mui/material'

// Story 213, C11.12 — one block of `BACKOFFICE › Camera control`: its number (none with 0), its title and, instead of
// paragraphs, a help "?" with the explanatory texts of the block.
const StepCard = ({ id, number = 0, title, help = [], action = false, children }) => (
  <Paper component='section' aria-labelledby={id} sx={{ p: 3, borderRadius: 3, bgcolor: 'background.paper' }}>
    <Stack spacing={2}>
      <Stack direction='row' alignItems='center' spacing={1.5}>
        {number !== 0 && (
          <Box
            data-testid='step-number'
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: '#2B3A31',
              color: 'primary.main',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '0 0 auto'
            }}
          >
            {number}
          </Box>
        )}
        <Typography id={id} variant='h6' component='h2' sx={{ fontWeight: 600, color: 'text.primary' }}>{title}</Typography>
        {help.length > 0 && (
          <Tooltip title={<Stack spacing={0.5}>{help.map((text) => <span key={text}>{text}</span>)}</Stack>}>
            <Button
              data-testid='step-help'
              aria-label={help.join(' ')}
              variant='outlined'
              color='inherit'
              sx={{ minWidth: 28, width: 28, height: 28, p: 0, borderRadius: '50%', fontWeight: 700, cursor: 'help' }}
            >
              ?
            </Button>
          </Tooltip>
        )}
        {action && <Box sx={{ ml: 'auto !important' }}>{action}</Box>}
      </Stack>
      {children}
    </Stack>
  </Paper>
)

export default StepCard
